var _excluded = ["isActive", "hasHoverState", "children", "htmlTagValue"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var arrowSvg = function arrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.64 6.05a.76.76 0 0 1-1.28 0L.16 1.4A.88.88 0 0 1 .8 0h6.4a.88.88 0 0 1 .64 1.4z"
  }));
};
arrowSvg.defaultProps = {
  width: "10",
  height: "8",
  viewBox: "0 0 8 6.4",
  xmlns: "http://www.w3.org/2000/svg"
};
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import transition from "../../../utils/transition";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
var activeColor = "primary";
var Arrow = styled(arrowSvg).withConfig({
  componentId: "sc-1tr9wna-0"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["", ";transform:", ";fill:", ";"], transition("transform", "fill"), $isActive && "rotate(-180deg)", $isActive ? getColor(theme, activeColor) : getIconColor(theme, $onColor));
});
var StyledToggleHeadingAtm = styled.h2.withConfig({
  componentId: "sc-1tr9wna-1"
})(function (_ref2) {
  var $hasHoverState = _ref2.$hasHoverState,
    $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["", ";", ";display:flex;align-items:center;justify-content:space-between;", ""], cssTextAtm({
    typography: "big3",
    onColor: $onColor
  }), transition("color"), $hasHoverState && css(["color:", ";"], getColor(theme, activeColor)));
});
function ToggleHeadingAtm(_ref3) {
  var isActive = _ref3.isActive,
    hasHoverState = _ref3.hasHoverState,
    children = _ref3.children,
    htmlTagValue = _ref3.htmlTagValue,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledToggleHeadingAtm, _extends({
    as: htmlTagValue,
    $hasHoverState: !!hasHoverState,
    $onColor: onColor
  }, restProps), children, /*#__PURE__*/React.createElement(Arrow, {
    $isActive: !!isActive,
    $onColor: onColor
  }));
}
export default ToggleHeadingAtm;